<template>
  <div id="app">
    <div>
      <Menu v-bind:app_lang="app_lang" v-bind:nav_height="nav_height"></Menu>
    </div>
    <div id="wrapper" :style="(!$route.meta.has_nav_effect) ? 'margin-top:' +nav_height['scrolled']+ 'px' : 'margin-top: 0px'">
      <transition :duration="{ enter: 400, leave: 300 }"
        enter-active-class="animated fadeIn faster"
        leave-active-class="animated fadeOut faster" 
        mode="out-in">

        <router-view :key="$route.fullPath"></router-view>

      </transition>
      <!-- <router-view :key="$route.fullPath"></router-view> -->
    </div>
  </div>
</template>
<script>

// @ is an alias to /src
import Menu from '@/components/Menu.vue'

export default {
  components: {
    Menu
  },
  data() {
    return {
      app_lang: localStorage.lang,
      nav_height: {
        'scrolled': 60,
        'default': 140,
      },
    }
  },
  watch: {
    '$route.params.lang': function(new_val, old_val) {
      this.app_lang = new_val;
    }
  },
  methods: {
    
  },
  created: function() {
      // alert(this.isIE);
  }
}
</script>
<style>
/*@import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700');*/
@import url('../node_modules/bootstrap/dist/css/bootstrap.css');
@import url('../node_modules/bootstrap-vue/dist/bootstrap-vue.css');
@import url('./assets/css/font-awesome_4.7.min.css');
@import url('./assets/css/animate_3.7.2.min.css');
@import url('https://fonts.googleapis.com/css?family=Cairo&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat:700&display=swap');


@font-face {
  font-family: 'Gotham';
  font-style: normal;
  font-weight: normal;
  src: local('Gotham'), url('assets/fonts/Gotham-Bold.otf') format('opentype');
}

html {
  min-height: 100%;
}
body {
  height: 100%;
  color: #00263d !important;
  font-family: 'Cairo', sans-serif !important;
}


*, *:before, *:after {
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
            box-sizing: border-box;
}
.cursor-pointer {
  cursor: pointer;
}
.text-overline {
  text-decoration: overline;
}
.section-title, .menu-link {
  font-family: 'Montserrat', sans-serif;
}
h1.section-title {
  
}
.content {
  margin-top: -200px;
}
.text-bold {
  font-weight: 700;
}
.text-semi-bold {
  font-weight: 600;
}
.font-size-0 {
  font-size: 0;
}
.font-size-16 {
  font-size: 16px;
}
.font-size-18 {
  font-size: 18px;
}
.font-size-20 {
  font-size: 20px;
}


h2.section-title {
  font-size: 1.8rem;
}
h3.section-title {
  font-size: 1.55rem;
}
h5.section-title {
  font-size: 1.1rem;
}

.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1;
}
.f-gotham {
  font-family: 'Gotham', 'Montserrat', sans-serif;
}

.container {
  max-width: 1000px !important;
}


#wrapper {
  transition: all .2s ease-in-out;
}
.container-top {
    margin-top: 60px; 
    min-height: 500px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center bottom;
}
.bg-grey {
  background-color: #eaeaea;
}
.line-up-dark {
  border-top: solid 3px #00263d;
  padding-top: 2px;
}
.line-up-white {
  border-top: solid 3px #ffffff;
  padding-top: 2px;
}
a:hover {
  text-decoration: none;
}

.bg-scale {
  overflow: hidden;
}
.bg-scale .bg {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transition: all .5s ease-in-out;
}
.bg-scale:hover .bg {
  transform: scale(1.07);
}

.bg-scale .bg-scale-content {
  left: 15px;
  right: 15px;
  z-index: 1;
  position: absolute;
}
.m-t-30 {
  margin-top: 30px;
}
.space-to-footer {
  padding-bottom: 80px;
}


/*COLORS BLUE
rgba(0, 38, 61, 1);
#00263d
*/

.border-ani-center-white::before {
  display:block;
  padding-top: 1px;
  content: '';
  border-top: solid 3px #ffffff;  
  transform: scaleX(0);
  transition: transform 250ms ease-in-out;
}
.border-ani-center-white:hover::before { transform: scaleX(1); }

.border-ani-center-dark::before {
  display:block;
  padding-top: 1px;
  content: '';
  border-top: solid 3px #00263d;  
  transform: scaleX(0);  
  transition: transform 250ms ease-in-out;
}
.border-ani-center-dark:hover::before { transform: scaleX(1); }

/*DEFAULT HEADERS FONT-SIZES

h1 { font-size: 2em; }
h2 { font-size: 1.5em; }
h3 { font-size: 1.17em; }
h4 { font-size: 1.12em; }
h5 { font-size: .83em; }
h6 { font-size: .75em; }*/



/*less than xl*/
@media screen and (max-width:1200px) {
    
}

/*less than lg*/
@media screen and (max-width:991.98px) {
    /*h1.section-title {
      font-size: 1.8em;
    }
    h2.section-title {
      font-size: 1.4em;
    }
    h3.section-title {
      font-size: 1.2em;
    }*/
    /*.w-md-100 {
      width: 100% !important;
    }
    .w-md-75 {
      width: 75% !important;
    }*/
}

/*grater than xl*/
@media screen and (min-width:1200px) {
    
}

/*greater than lg*/
@media screen and (min-width:991.98px) {
    /*h1.section-title {
      font-size: 1.8em;
    }
    h2.section-title {
      font-size: 1.4em;
    }
    h3.section-title {
      font-size: 1.2em;
    }*/
    .w-md-100 {
      width: 100% !important;
    }
    .w-md-75 {
      width: 75% !important;
    }
}

/*less than md*/
@media screen and (max-width:767.98px) {
    h1.section-title {
      font-size: 1.8em;
    }
    h2.section-title {
      font-size: 1.4em;
    }
    h3.section-title {
      font-size: 1.2em;
    }

    h5.section-title {
      font-size: .75em;
    }
    .font-size-md-16 {
      font-size: 16px;
    }
    .content {
      margin-top: 0;
    }
    .container-top {
      min-height: 250px;
    }
    
}

/*greater than md*/
@media screen and (min-width:767.98px) {
    .w-sm-100 {
      width: 100% !important;
    }
    .w-sm-75 {
      width: 75% !important;
    }
}


/*less than sm*/
@media (max-width: 575.98px) {

}
@media screen and (max-width:400px) {
    @-ms-viewport{
        width:320px;
    }
}
/* ROUTER ANIMATION */



</style>
